import { initApi } from './init-api';
import { initKeyring } from './init-keyring';

export async function initStartupFunctions() {
	await initKeyring();
	await initApi();
}
